import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import propTypes from 'prop-types';
import { routes } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { getWindow } from '@shared/services/window';
import { setSuggestionsRequestId } from 'actions/actions';
import { getNpsModule } from '@appsource/utils/nps';
import { Header as RemoteAppSourceHeader } from '@agoras/view';
import { generateUrlNavigation } from './Navigation';
import { getSearchNavigationUrl } from './Search';
const RemoteHeader = ({ market, locale, userProps, onMarketChange, onLocaleChange }, context)=>{
    const { buildHref } = context;
    const activeFilters = useSelector((state)=>state.apps.activeFilters.filter((activeFilter)=>Boolean(activeFilter.BackendKey)));
    const unifiedExperience = useSelector(({ config })=>config.isConverged);
    const isSearchInHero = useSelector(({ config })=>config.isSearchInHero);
    const currentView = useSelector(({ config })=>config.currentView);
    const searchInHero = currentView === routes.home.name && isSearchInHero;
    const filters = currentView === routes.home.name ? [] : activeFilters;
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const handleNavigation = (options)=>{
        var _getNpsModule;
        const url = generateUrlNavigation(buildHref, options);
        if (url) {
            navigate(url);
        }
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.increaseActionsCounter(Constants.NpsActions.galleryChangesCount);
        getWindow().scrollTo(0, 0);
    };
    const handleSearch = (options)=>{
        const { gallery, searchTerm, useCurrentFilters, suggestionsRequestId } = options;
        const url = getSearchNavigationUrl(buildHref, {
            gallery,
            searchTerm,
            useCurrentFilters
        });
        const entityType = Constants.EntityType[`${gallery}`];
        if (entityType !== Constants.EntityType.Partner) {
            dispatch(setSuggestionsRequestId({
                suggestionsRequestId
            }));
        }
        navigate(url);
    };
    return /*#__PURE__*/ _jsx(RemoteAppSourceHeader, {
        userProps: userProps,
        navigate: handleNavigation,
        logger: logger,
        market: market,
        locale: locale,
        searchProps: {
            onSearch: handleSearch,
            filters,
            isSearchInHero: searchInHero
        },
        location: location,
        onMarketChange: onMarketChange,
        onLocaleChange: onLocaleChange,
        unifiedExperience: unifiedExperience,
        currentView: currentView
    });
};
RemoteHeader.contextTypes = {
    buildHref: propTypes.func
};
export default RemoteHeader;
